<template>
  <div class="order" style="padding-bottom: 60px" >
    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">支付</p>
      </div>
    </header>
  <div class="center">
   <p>需要支付金额：<span style="color:#ff6034">￥{{number}}</span></p>
  </div>
    <!--<van-submit-bar :price="3050"  button-text="提交订单" >-->
    <!--<p>共计</p>-->
    <!--</van-submit-bar>-->
    <!--<van-submit-bar :price="3050" button-text="提交订单" @submit="onSubmit">-->
    <!--<van-checkbox v-model="checked">全选</van-checkbox>-->
    <!--<template #tip>-->
    <!--你的收货地址不支持同城送, <span @click="onClickEditAddress">修改地址</span>-->
    <!--</template>-->
    <!--</van-submit-bar>-->
    <!--<van-submit-bar :price="3050"   />-->
    <!--<p @click="saveCart">code</p>-->
    <div class="inforName">
      <van-button style="width:100%;height:2.5rem" color="red" type="primary" @click.native.once="Wxpay()">立即支付</van-button>

    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Swipe, SwipeItem } from 'vant';

  Vue.use(Swipe);
  Vue.use(SwipeItem);
  //  import Vue from 'vue';
  import { Lazyload } from 'vant'
  Vue.use(Lazyload);
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        list:[],
        address:{},
        number:"",
        code:"",
        order:""
      }
    },
    created(){

    },
    beforeRouteLeave(to,from,next){
      console.log(to,from)
      console.log(this.$router)
      if(to.path=="/orderPage"){
        this.$router.push({path:"/newShop"})
      }
      next()
    },
    methods: {
      backHistory(){
        this.$dialog.alert({
          title: '确认离开支付中心？',
          message: '',
          showCancelButton:true
        }).then(() => {
          this.$router.push({
            path:"/newShop"
//            path:"/collageHome"
          })
        });

      },
      onSwipeLeft () {
        this.$dialog.alert({
          title: '确认离开支付中心？',
          message: '',
          showCancelButton:true
        }).then(() => {
          this.$router.push({
            path:"/newShop"
          })
        });
      },
      toAddress(){
        this.$router.push("/harvestAddress")
      },

      _totalPeice () {
        this.number = this.$route.query.id
        this.allCount = ""
      },
      Wxpay(){
        let _this=this
//        alert(1)
        this.$api.Wxpay({
          code:this.code,
          order_number:localStorage.getItem("order"),
          user_id:localStorage.getItem("userid"),
        }).then(res=>{
//          alert(JSON.stringify(res))
          var data=JSON.parse(res)
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId":data.appId,     //公众号名称，由商户传入
              "timeStamp":data.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":data.nonceStr, //随机串
              "package":data.package,
              "signType":data.signType,         //微信签名方式：
              "paySign":data.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ){
//                window.location.href="https://m.shangshebao.com/shop/#/allOrder"
                if(localStorage.getItem("shoptid")){
                  _this.$router.push({
                    path:"/collageHome"
                  })
                }else {
                  window.location.href="https://m.shangshebao.com/shop/#/allOrder"
                }
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                /* if(type=='bc'){
                                        window.location.href='https://m.shangshebao.com/orderfxpintuan.html'
                                    }else{ */
//                window.location.href='https://m.shangshebao.com/order/index.html'
                //}

              }else {
                // 支付失败跳转

                window.location.href="https://m.shangshebao.com/shop/#/allOrder"
              }
            });
        }).catch(res=>{
//          alert(JSON.stringify(res))
        })
      },
      saveCart(){
        let code=this.$route.query.id
        let href="https://m.shangshebao.com/shop/#/pay?id="+code+"&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect"
        let Jumpurl = encodeURIComponent(href);
        this.code = this.getUrlParam('code');
        if (this.code==null) {
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7bd203a60100c6d4&redirect_uri="+Jumpurl+"&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect"
        }

      },
      getUrlParam (name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let url = window.location.href.split('#')[0]
        let search = url.split('?')[1]
        if (search) {
          var r = search.substr(0).match(reg)
          if (r !== null) return unescape(r[2])
          return null
        } else {
          return null
        }
      }
    },
    mounted(){
      this._totalPeice()
      this.saveCart()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  header{
    width: 100%;
    height: 60px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 60px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 18px;
  }
  .order{
    width: 100%;
    height: 100%;
    background: #E4E4E4;
    padding-top: 70px;
  }
  .center{
    width: 100%;
    height: 5rem;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .center p{
    font-size: 15px;

  }
  .inforName{
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/pay.vue